// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const APP_VERSION = {
    version: null,
    tag: null,
    commitHash: '9905fccd3',
    branchName: 'feature/SHP-8515-auth0',
    timestamp: '2025-12-02T05:15:58.968Z',
};
